import { BaseDto } from '@/shared/dtos/base-dto';

export class recomendacion extends BaseDto {
    public id_paciente !: number;
    public id_dieta !: number;
    public id_nutricionista !: number;

} 
